import React from 'react';
import { StyleSheet, View } from 'react-native';
import { Button, Text } from 'react-native-paper';
import { useTranslation } from 'react-i18next';
import { useAppColors } from '../../hooks/useAppColors';
import { useAuthStore } from '../../stores/authStore';
import { useLogout } from '../../hooks/useAuth';
import { useLegalStatus } from '../../hooks/useLegal';
import LoadingIndicator from '../../components/common/LoadingIndicator';

export default function SubUserBlockedScreen() {
  const { t } = useTranslation();
  const colors = useAppColors();
  const logout = useLogout();
  const { data: status, isLoading, refetch } = useLegalStatus();

  if (isLoading) {
    return <LoadingIndicator />;
  }

  return (
    <View style={[styles.container, { backgroundColor: colors.bg }]}>
      <Text style={[styles.title, { color: colors.text }]}>{t('legal.subUserBlockedTitle')}</Text>
      <Text style={[styles.body, { color: colors.textSecondary }]}>
        {t('legal.subUserBlockedBody')}
      </Text>
      <View style={styles.actions}>
        <Button mode="contained" onPress={() => refetch()} style={styles.button} buttonColor={colors.accent} textColor="#fff">
          {t('common.retry')}
        </Button>
        <Button mode="outlined" onPress={logout} style={styles.button} textColor={colors.text}>
          {t('common.logout')}
        </Button>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: { flex: 1, justifyContent: 'center', alignItems: 'center', padding: 24 },
  title: { fontSize: 20, fontWeight: '700', marginBottom: 12, textAlign: 'center' },
  body: { fontSize: 15, textAlign: 'center', marginBottom: 24, lineHeight: 22 },
  actions: { width: '100%', maxWidth: 300, gap: 12 },
  button: { borderRadius: 8 },
});
